export default "__VITE_ASSET__BTep4Z4i__"